import { SaleStaffType } from "features/sale-staffs/type";
import { Staff } from "features/staff/types";
import { GENDER, USER_TYPE } from "types";

export interface Merchant {
	id: number;
	username: string;
	fullName: string | null;
	avatar: string | null;
	imageUrl?: string | null;
	phoneNumber: string | null;
	email: string | null;
	idCard: string | null;
	gender: GENDER;
	birthday: string | null;
	status: MerchantStatus;
	address: string | null;
	userType: USER_TYPE;
	title?: string | null;
	contractDate?: string | null;
	contract?: string | null;
	isRemoved: boolean;
	createdAt?: string;
	updatedAt?: string;
	documents?: Document[];
	staff?: Staff;
	saleStaff?: SaleStaffType;
	data?: Merchant;
	province?: number;
	ward?: number;
	district?: number;
	userAddress?: queryMerchantAddress | null;
	subscriptionClass?: number;
	type?: MERCHANT_TYPE;
	mou?: MOU_STATUS;
	origin?: number;
}

export enum MERCHANT_TYPE {
	PARTNER = "partner",
	NORMAL = "normal",
	IMPORT_PARTNER = "import_partner",
}

export enum MOU_STATUS {
	ENABLED = "enabled",
	DISABLED = "disabled",
}

export interface ResponseMerchant {
	id: number;
	username: string;
	fullName: string | null;
	avatar: string | null;
	imageUrl?: string | null;
	phoneNumber: string | null;
	email: string | null;
	idCard: string | null;
	gender: GENDER;
	birthday: string | null;
	status: MerchantStatus;
	address: string | null;
	userType: USER_TYPE;
	title?: string | null;
	contractDate?: string | null;
	contract?: string | null;
	isRemoved: boolean;
	createdAt?: string;
	updatedAt?: string;
	documents?: Document[];
	staff?: Staff;
	saleStaff?: SaleStaffType;
	data?: Merchant;
	province?: number;
	ward?: number;
	district?: number;
	userAddress?: MerchantAddress | null;
	subscriptionClass?: number;
	type?: MERCHANT_TYPE;
	mou?: MOU_STATUS;
	origin?: number;
}

export interface MerchantAdress {
	province?: number;
	ward?: number;
	district?: number;
}
export interface MerchantAddress {
	province?: Address;
	ward?: Address;
	district?: Address;
}

export interface Address {
	id: number;
}

export interface queryMerchantAddress {
	province?: number;
	ward?: number;
	district?: number;
}
export interface IdName {
	id: number;
	name: string;
}

export interface MerchantPayload extends Omit<Merchant, "staff"> {
	staff?: Staff | number;
}

export interface MerchantQueries {
	skip?: number;
	take?: number;
	status?: boolean | null;
	fullName?: string | null;
	phoneNumber?: string | null;
	email?: string | null;
	isRemoved?: boolean | null;
	saleStaff?: SaleStaffType;
	saleStaffId?: number;
	subscriptionClass?: string | null;
	type?: MERCHANT_TYPE | null;
	mou?: MOU_STATUS | null;
}

export interface MerchantQueriesPayload extends MerchantQueries {
	saleStaffId?: number;
}

export enum MerchantStatus {
	ENABLE = "enable",
	DISABLE = "disable",
	UNPAID = "unpaid",
	WAITING_FOR_REVIEW = "Waiting for review",
}

export enum MerchantSubscriptionStatus {
	EMPTY = 0,
}

export interface Contract {
	path: string;
	name: string;
	documentType?: string;
	documentDate?: string;
	status: string;
}

export interface Document {
	documentType: string;
	documents?: Contract[];
}

export interface MerchantSaleReport {
	merchantId: number | string;
	pendingCount: number;
	processingCount: number;
	totalRevenue: number;
	soldCount: number;
	totalPublishPrice: number;
	purchasingCount: number;
	unPublishCount: number;
	approvedCount: number;
	publishCount: number;
	rejectCount: number;
}

export interface ConflictedTransaction {
	id: string;
	type: string;
}

export interface ConflictedTransactionResponse {
	id: string;
	status: string;
	type: string;
}

export interface ConflictedResponse {
	bookings: ConflictedTransactionResponse[];
	purchaseOrders: ConflictedTransactionResponse[];
	totalBookings: number;
	totalPurchaseOrders: number;
}

export interface Benefit {
	code: string;
	quota: number;
	type: string;
	unlimited: boolean;
	duration: number;
	hidden: boolean;
}

export interface Price {
	price: number;
	duration: number;
	discount: number;
	quotation: number;
}

export interface SubscriptionPackage {
	id: number;
	benefits: Benefit[];
	annualMembership: number;
	commissions: {
		fee: number;
		percent: number;
	}[];
	icon: string;
	name: string;
	ordinal: number;
	type: string;
	status: string;
	isBestSeller: boolean;
	prices: Price[];
}

export interface PaymentFile {
	id: number;
	name: string;
	paymentDate: string;
	path: string;
	url: string;
}
